import { FilterPeriodType } from './constants';

export const getFilterPeriod = (
  filterPeriod: string,
  monthSelected: Date | null,
  startDate: Date | null,
  endDate: Date | null
): [Date, Date] => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();

  if (filterPeriod === FilterPeriodType.CURRENT_MONTH) {
    return [currentDate, currentDate];
  } else if (
    filterPeriod === FilterPeriodType.SPECIFIC_PERIOD &&
    startDate !== null &&
    endDate !== null
  ) {
    return [startDate, endDate];
  } else if (
    filterPeriod === FilterPeriodType.SPECIFIC_MONTH &&
    monthSelected !== null
  ) {
    return [monthSelected, monthSelected];
  } else if (filterPeriod === FilterPeriodType.CURRENT_YEAR) {
    const newStartDate = new Date(`${currentYear}-01-01`);

    return [newStartDate, currentDate];
  } else if (filterPeriod === FilterPeriodType.LAST_YEAR) {
    const newStartDate = new Date(`${currentYear - 1}-01-01`);
    const newEndDate = new Date(`${currentYear - 1}-12-30`);

    return [newStartDate, newEndDate];
  } else if (filterPeriod === FilterPeriodType.LAST_TWELVE_MONTHS) {
    const newStartDate = new Date(`${currentYear - 1}-${currentMonth + 2}-01`);

    return [newStartDate, currentDate];
  }
  return [currentDate, currentDate];
};

export const getFilterRefMonth = (
  filterPeriod: string,
  monthSelected: Date | null,
  startDate: Date | null,
  endDate: Date | null
): [string, string] => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, '0');

  if (filterPeriod === FilterPeriodType.CURRENT_MONTH) {
    return [`${currentYear}_${currentMonth}`, `${currentYear}_${currentMonth}`];
  }

  if (
    filterPeriod === FilterPeriodType.SPECIFIC_PERIOD &&
    startDate !== null &&
    endDate !== null
  ) {
    const startYear = startDate.getFullYear().toString();
    const startMonth = (startDate.getMonth() + 1).toString().padStart(2, '0');

    const endYear = endDate.getFullYear().toString();
    const endMonth = (endDate.getMonth() + 1).toString().padStart(2, '0');

    return [`${startYear}_${startMonth}`, `${endYear}_${endMonth}`];
  }

  if (
    filterPeriod === FilterPeriodType.SPECIFIC_MONTH &&
    monthSelected !== null
  ) {
    const year = monthSelected.getFullYear().toString();
    const month = (monthSelected.getMonth() + 1).toString().padStart(2, '0');

    return [`${year}_${month}`, `${year}_${month}`];
  }

  if (filterPeriod === FilterPeriodType.CURRENT_YEAR) {
    return [`${currentYear}_01`, `${currentYear}_${currentMonth}`];
  }

  if (filterPeriod === FilterPeriodType.LAST_YEAR) {
    // const newStartDate = new Date(`${currentYear - 1}-01-01`);
    // const newEndDate = new Date(`${currentYear - 1}-12-30`);

    return [`${currentYear - 1}_01`, `${currentYear - 1}_12`];
  }

  if (filterPeriod === FilterPeriodType.LAST_TWELVE_MONTHS) {
    // Em dezembro o início é janeiro do MESMO ano (antes gerava "AAAA_13").
    if (currentMonth === '12') {
      return [`${currentYear}_01`, `${currentYear}_12`];
    }
    const startMonth = (Number(currentMonth) + 1).toString().padStart(2, '0');
    return [
      `${currentYear - 1}_${startMonth}`,
      `${currentYear}_${currentMonth}`,
    ];
  }

  return [`${currentYear}_${currentMonth}`, `${currentYear}_${currentMonth}`];
};
